import React from "react";
import {
  ProgressBarContainer,
  ProgressFill,
  ProgressTrack,
  StepContainer,
  StepLabel,
  StepMarker,
  StepWrapper,
} from "./Styled";
import { Box, HeadingStyled, HeadingStyledSm } from "../../../components/styled/Elements";
import { Check } from "../../../components/styled/AllImages";

const CustomProgressBar = ({ currentStep, steps }) => {
  return (
    <ProgressBarContainer>
      {steps.map((step, index) => {
        const stepNumber = index + 1;

        // Determine classes based on current step
        const isDone = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;

        return (
          <Box
            key={stepNumber}
            className={`progress-step ${
              isDone ? "done" : isActive ? "current" : ""
            }`}
          >
            <Box className="step-number">
              <Box className="stepNumberInner">
                {isDone ? (
                  <span className="checkmark">
                    <Check />
                  </span>
                ) : (
                  <span></span>
                  //   <span>{stepNumber}</span>
                )}
              </Box>
            </Box>
            <Box className="step-label">
              <Box className="stepCountContent">
                <Box className="stepCountTitle">{step?.title}</Box>
                <HeadingStyled className="stepTitle" size="16px">
                  {step?.heading}
                </HeadingStyled>
                <HeadingStyledSm size="14px" className="stepCountStatus">
                  {step?.status}
                </HeadingStyledSm>
              </Box>
            </Box>
            {/* <Box className="step-label">{step}</Box> */}
          </Box>
        );
      })}
      <Box className="progress-line">
        <Box
          className="progress-fill"
          style={{
            width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
          }}
        ></Box>
      </Box>
    </ProgressBarContainer>
  );
};

export default CustomProgressBar;

/* 
const CustomProgressBar = ({ currentStep, steps }) => {
	const percentage = ((currentStep - 1) / (steps.length - 1)) * 100;

	return (
		<Box>
			<ProgressBarContainer>
				<ProgressTrack>
					<ProgressFill percentage={percentage} />
					{steps.map((step, index) => (
						<StepMarker
							key={index}
							position={(index / (steps.length - 1)) * 100}
							active={index < currentStep}
						>
							{index + 1}
						</StepMarker>
					))}
				</ProgressTrack>
			</ProgressBarContainer>
			<StepWrapper>
				{steps.map((step, index) => (
					<StepContainer key={index}>
						<StepLabel active={index < currentStep}>{step}</StepLabel>
					</StepContainer>
				))}
			</StepWrapper>
		</Box>
	);
};

export default CustomProgressBar; */
